import React from 'react';
import { View, StyleSheet } from 'react-native';
import { Button, ButtonGroup, rem } from 'design-system';
import Modal from 'utils/packages/Modal';
import Text from 'design-system/Text';
const BankIssueModalContent = ({ onPressContinue, strings, icon, }) => (<View>
    <View style={styles.modalTitleContainer}>
      {icon}
      <Text Text-20 centered style={styles.modalTitle}>
        {strings.title}
      </Text>
    </View>
    <Text TextThin-14 Secondary centered style={styles.description}>
      {strings.description}
    </Text>
    <ButtonGroup margins={false}>
      <Button brandReversed title={strings.tryLater} onPress={() => Modal.hide()}/>
      <Button brand title={strings.continue} onPress={onPressContinue}/>
    </ButtonGroup>
  </View>);
const styles = StyleSheet.create({
    modalTitleContainer: {
        marginTop: rem(40),
        alignItems: 'center',
    },
    modalTitle: {
        marginVertical: rem(16),
    },
    description: {
        marginBottom: rem(34),
    },
});
export default BankIssueModalContent;
